/**
 * @generated SignedSource<<3cda995dea699acd15fd7a460ca18dea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetAppBuildNumbersInput = {
  androidBuildNumber?: string | null;
  clientMutationId?: string | null;
  iosBuildNumber?: string | null;
};
export type appBuildNumber_setAppBuildNumbersMutation$variables = {
  input: SetAppBuildNumbersInput;
};
export type appBuildNumber_setAppBuildNumbersMutation$data = {
  readonly Admin: {
    readonly App: {
      readonly setAppBuildNumbers: {
        readonly appVersion: {
          readonly " $fragmentSpreads": FragmentRefs<"appBuildNumber_AppVersionFragment">;
        };
      } | null;
    };
  };
};
export type appBuildNumber_setAppBuildNumbersMutation = {
  response: appBuildNumber_setAppBuildNumbersMutation$data;
  variables: appBuildNumber_setAppBuildNumbersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "appBuildNumber_setAppBuildNumbersMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppAdminMutationSchema",
            "kind": "LinkedField",
            "name": "App",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetAppBuildNumbersPayload",
                "kind": "LinkedField",
                "name": "setAppBuildNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppVersion",
                    "kind": "LinkedField",
                    "name": "appVersion",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "appBuildNumber_AppVersionFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "appBuildNumber_setAppBuildNumbersMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppAdminMutationSchema",
            "kind": "LinkedField",
            "name": "App",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "SetAppBuildNumbersPayload",
                "kind": "LinkedField",
                "name": "setAppBuildNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppVersion",
                    "kind": "LinkedField",
                    "name": "appVersion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "iosBuildNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "androidBuildNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1df4681ef358269b28824a544134428",
    "id": null,
    "metadata": {},
    "name": "appBuildNumber_setAppBuildNumbersMutation",
    "operationKind": "mutation",
    "text": "mutation appBuildNumber_setAppBuildNumbersMutation(\n  $input: SetAppBuildNumbersInput!\n) {\n  Admin {\n    App {\n      setAppBuildNumbers(input: $input) {\n        appVersion {\n          ...appBuildNumber_AppVersionFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment appBuildNumber_AppVersionFragment on AppVersion {\n  iosBuildNumber\n  androidBuildNumber\n}\n"
  }
};
})();

(node as any).hash = "f0497ebb89a102f3741cbde32a149e6f";

export default node;
